import firebase from "firebase";
import logging from '@/assets/js/functions/_core/logging';

export default {
  mixins: [logging],

  methods: {
    async createAuthUser(authData) {
      await firebase.auth().createUserWithEmailAndPassword(
        authData.email,
        authData.password
      ).catch(error => {
        this.logger(error, "ユーザーデータの登録に失敗しました");
        throw error;
      });
    },
  }
}